import { render, staticRenderFns } from "./SQuesFifteen.vue?vue&type=template&id=6acdbd47&"
import script from "./SQuesFifteen.vue?vue&type=script&lang=js&"
export * from "./SQuesFifteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports